import $ from 'jquery';
import '@/vendor/jquery.usmap';
import 'bootstrap/js/dist/tab';

function renderMap(mapDiv, mapData) {
  var statusColors = {'A': '#dff0d8', 'R': '#f2dede'};
  var stateStyles = {};
  var stateLabelBackingStyles = {};
  var stateLabelBackingHoverStyles = {};
  var stateLabelTextHoverStyles = {};
  var stateHoverStyles = {};

  mapData.forEach((state) => {
    stateStyles[state.abbreviation] = { fill: statusColors[state.status] };
    stateLabelBackingStyles[state.abbreviation] = { fill: statusColors[state.status] };
    stateLabelBackingHoverStyles[state.abbreviation] = { fill: '#666' };
    stateLabelTextHoverStyles[state.abbreviation] = { fill: '#fff' };
    stateHoverStyles[state.abbreviation] = { fill: '#666' };
  });

  $(mapDiv).usmap({
    showLabels: true,
    labelBackingStyles: { fill: '#eee' },
    labelBackingHoverStyles: { fill: '#eee' },
    labelTextHoverStyles: { fill: '#666' },
    stateHoverStyles: { fill: '#eee' },
    stateSpecificStyles: stateStyles,
    stateSpecificLabelBackingStyles: stateLabelBackingStyles,
    stateSpecificLabelBackingHoverStyles: stateLabelBackingHoverStyles,
    stateSpecificLabelTextHoverStyles: stateLabelTextHoverStyles,
    stateSpecificHoverStyles: stateHoverStyles,
    click: function(event, data) {
      var state = mapData.find(s => s.abbreviation === data.name);
      if (state && state.url) {
        window.location = state.url;
      }
    }
  });

  $(mapDiv).on('usmapmouseover', function(event, data) {
    var state = mapData.find(s => s.abbreviation === data.name);
    if (state && state.url) {
      $(`${mapDiv} > svg > path, ${mapDiv} > svg > rect`).each(function() {
        $(this).css('cursor', 'pointer');
      });
    } else {
      $(`${mapDiv} > svg > path, ${mapDiv} > svg > rect`).each(function() {
        $(this).css('cursor', 'default');
      });
    }
  });
}

$(document).ready(function() {
  // Render map of default tab.
  renderMap('#zevMap', $('#zevMap').data('zev-map'));

  // Update URL on tab change for deep linking.
  document.querySelectorAll('[data-bs-toggle="tab"]').forEach((tabEl) => {
    tabEl.addEventListener('shown.bs.tab', () => {
      window.history.replaceState(null, '', tabEl.getAttribute('href'));

      // The map needs to be rendered each time the tab is switched, since the
      // mapping library won't work if rendered into a hidden div.
      const standard = tabEl.getAttribute('href').replace("#/tab-", '');
      renderMap(`#${standard}Map`, $(`#${standard}Map`).data(`${standard}-map`));
    })
  });

  // Trigger tab switch on-load for deep links.
  const hash = window.location.hash;
  if (hash) {
    document.querySelector(`a[data-bs-toggle="tab"][href="${hash}"]`)?.click();
  }
});
